import { Component, Input } from "@angular/core";

@Component({
    selector: "activity-indicator",
    templateUrl: "./activity-indicator.component.html",
    styleUrls: ["./activity-indicator.component.scss"],
    standalone: false
})
export class ActivityIndicatorComponent {
  @Input()
  showLoader = true;
}
